<ng-container *transloco="let t; prefix: scope">
  @if (currentProfile$ | async; as profile) {
    @if (hasMultipleProfiles$ | async) {
      <h2 mat-dialog-title>{{ t('titleSwitchAccount') }}</h2>
    } @else {
      <h2 mat-dialog-title>{{ t('title') }}</h2>
    }
    <button type="button" class="close-button" mat-dialog-close mat-icon-button><rma-icon glyph="close" theme="primary" /></button>
    <mat-dialog-content class="dialog-content">
      <div class="user-list">
        <ng-container
          *ngTemplateOutlet="
            userItem;
            context: {
              profileImage: profile.profileImage,
              primaryColour: userPrimaryColour$ | async,
              name: profile.fullName,
              selected: true,
            }
          "
        />
        @for (profile of profiles$ | async; track profile.code) {
          <button type="button" class="user-list-select" (click)="switchUser(profile)">
            <ng-container
              *ngTemplateOutlet="
                userItem;
                context: { profileImage: profile.profileImage, primaryColour: profile.primaryColour, name: profile.name }
              "
            />
          </button>
        }
      </div>
    </mat-dialog-content>
    @if (!hideActions) {
      <mat-dialog-actions>
        <div class="action-list">
          <a class="item" routerLink="/manage-account" data-id="manage-account" mat-dialog-close>
            @if (isCurrentProfileAgency$ | async) {
              <rma-icon glyph="settings" theme="primary" /><span class="text">{{ t('manageAccount') }}</span>
            } @else {
              <rma-icon glyph="local_atm" theme="primary" /><span class="text">{{ t('billingAndSubs') }}</span>
            }
          </a>
          @if (showAddTeamAccount$ | async) {
            <a
              class="item"
              [queryParams]="teamsQueryParams$ | async"
              routerLink="/billing/subscription-features"
              data-id="add-team-account"
              mat-dialog-close
            >
              <rma-icon glyph="add" theme="primary" /><span class="text">{{ t('addTeamAccount') }}</span>
            </a>
          }
          <button type="button" class="item" (click)="onLogout()" data-id="logout">
            <rma-icon glyph="exit_to_app" theme="primary" /><span class="text logout">{{ t('logout') }}</span>
          </button>
        </div>
      </mat-dialog-actions>
    }
  }

  <ng-template #userItem let-profileImage="profileImage" let-primaryColour="primaryColour" let-name="name" let-selected="selected">
    <span class="item">
      <img
        alt=""
        class="avatar"
        class="h-8 w-8 object-cover"
        [style.background-color]="primaryColour"
        [src]="profileImage | rmaOptimiseImage: 'Square200'"
        height="24"
        width="24"
      />
      <span class="text">{{ name }}</span>
      @if (selected) {
        <rma-icon glyph="check" />
      }
    </span>
  </ng-template>
</ng-container>
